import { connect } from 'react-redux'
import PackageView from './PackageView';


const mapStateToProps = ( state ) => {
    return {
        pkg : state.packageView || {}
    }
};


const mapDispatchToProps = ( dispatch ) => {
    return {
        updatePackageView : ( packageName, type = null, channel = null, signature = null ) => (
            dispatch(
                {
                    type : 'PACKAGE_FETCH_REQUESTED',
                    packageName,
                    opts : { type, channel, signature }
                }
            )
        )
    };
};


const ReduxPackageView = connect(
    mapStateToProps,
    mapDispatchToProps
)( PackageView );


export default ReduxPackageView;



// WEBPACK FOOTER //
// ./src/lib/components/PackageView/index.js